
import React, { useEffect, useState } from 'react';
import Table from '../common/SettlementsHistory';
import tableConfig, { data } from './config';
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '../common/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from '../common/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { DAY_WISE_SETTLEMETS } from '../../constants';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SettlementsHistory = (props) => {
  const classes = props.classes,
    history = useHistory(),
    params = useParams();
  let sellerId = params.id,
    sellerName = params.name,
    config = tableConfig(props),
    session = sessionStorage.getItem('user');
  const [settleurl, setSettleUrl] = useState(`${DAY_WISE_SETTLEMETS}${sellerId}/day/wised/settlements?countryId=${countryid}&settlementsFor=afterLastSettlement`);
  const [state, setState] = useState({ isLoading: false, fromdate: null, todate: null, period: '', showdiv: false });
  const [countryid, setCountryid] = useState(`${JSON.parse(session).countryId}`);
  const [tableKey, setTableKey] = useState(1);

  const getFromDate = (event) => {
    let frDate = event.getFullYear() + "-" + (event.getMonth() + 1) + "-" + event.getDate();
    setState.fromdate(frDate);
  }

  const getToDate = (event) => {
    let toDate = event.getFullYear() + "-" + (event.getMonth() + 1) + "-" + event.getDate();
    setState.todate(toDate);
  }
  const handlePeriod = (event) => {
    if (event.target.value == "custom") {
      setState.showdiv(true);
    } else {
      setState.showdiv(false);
    }
    setState.period(event.target.value);
  }

  const setAPIURL = (event) => {
    setSettleUrl(`${DAY_WISE_SETTLEMETS}${sellerId}/day/wised/settlements?countryId=${countryid}&settlementsFor=${state.period}&fromDate=${fromdate}&toDate=${todate}`);
    setTableKey(tableKey + 1);
  }
  const reSetValues = () => {
    setState.period('');
    setState.fromdate(null);
    setState.todate(null);
    setSettleUrl(`${DAY_WISE_SETTLEMETS}${sellerId}/day/wised/settlements?countryId=${countryid}&settlementsFor=afterLastSettlement`)
    setTableKey(tableKey + 1);
  }

  return (
    <div style={{ width: '100%' }}>
      <div className="row" style={{ padding: "20px" }}>
        <Grid item xs={11}><h4><strong>{`${sellerName}'s`} Settlement History</strong></h4></Grid>
        <Grid item xs={1}>
          <Button onClick={() => { history.goBack(); }} size="small" label="Back"></Button>
        </Grid>
      </div>
      <div style={{ width: '100%' }}>
        <Card>
          <CardContent>
            <div className="row" style={{ marginLeft: '10px' }}>

              <Grid container spacing={2} className={'mt-3 '}>
                <Grid item xs={3}>
                  <FormControl className={classes.formControl}>
                    <Select
                      labelId="demo-simple-select-placeholder-label-label"
                      id="demo-simple-select-placeholder-label"
                      name="period"
                      value={state.period}
                      onChange={(e) => { handlePeriod(e) }}
                      displayEmpty
                      classes={{ select: classes.inputRoot }}
                    >
                      <MenuItem value="">
                        <em>------Select------</em>
                      </MenuItem>
                      <MenuItem value="afterLastSettlement">After LastSettlement</MenuItem>
                      <MenuItem value="today">Today</MenuItem>
                      <MenuItem value="yesterday">Yesterday</MenuItem>
                      <MenuItem value="thisWeek">This Week</MenuItem>
                      <MenuItem value="thisMonth">This Month</MenuItem>
                      <MenuItem value="previousWeek">Previous Week</MenuItem>
                      <MenuItem value="previousMonth">Previous Month</MenuItem>
                      <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} style={{ display: state.showdiv ? "block" : "none" }}>
                  <DatePicker
                    onChange={(e) => { getFromDate(e) }}
                    value={state.fromdate}
                    placeholderText="From Date"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    dropdownMode="select"
                    inlineFocusSelectedMonth
                  />
                </Grid>
                <Grid item xs={2} style={{ display: state.showdiv ? "block" : "none" }}>
                  <DatePicker
                    onChange={(e) => { getToDate(e) }}
                    value={state.todate}
                    placeholderText="To Date"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    dropdownMode="select"
                    inlineFocusSelectedMonth
                  />
                </Grid>
                <Grid item xs={1}>
                  <input type="button" className={classes.button} value="Search" onClick={(e) => { setAPIURL(e) }} />
                </Grid>
                <Grid item xs={1}>
                  <input type="button" className={classes.button} value="Reset" onClick={(e) => { reSetValues(e) }} />
                </Grid>
              </Grid>
            </div>
          </CardContent>
        </Card>
      </div>

      <Table
        key={tableKey}
        noBorder={true}
        tableConfig={config}
        data={data}
        apidata="records"
        countryid={countryid}
        url={settleurl}
      />
    </div>
  )
};

export default SettlementsHistory;
